export default __webpack_public_path__ + "static/media/HammerStrength.70cd30f7.png";